import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./reducers/authSlice";
import disputeSlice from "./reducers/Dispute/disputeSlice";
import globalSlice from "./reducers/globalSlice";

// const composeEnhancers = composeWithDevTools({
//   realtime: true,
//   name: "Reconciliation",
//   hostname: "localhost",
//   port: 3000, // the port your remotedev server is running at
// });


// // Apply middlewares
// const middlewareEnhancer = composeEnhancers(
//   applyMiddleware( /* Add more middlewares if needed */)
// );

export const store = configureStore({
  reducer: {
    globalSlice: globalSlice,
    authSlice: authSlice,
    disputeSlice: disputeSlice,
  },

  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk), // Add custom middlewares if needed
  // enhancers: [middlewareEnhancer],

  // devTools: process.env.REACT_APP_ENVOIRMENT === "development" ? true : false,
});
